import { AxiosResponse } from 'axios';
import { useInfiniteQuery, UseInfiniteQueryResult } from 'react-query';
import { PaginatedGLMKiloRecordListList } from 'types';
import { client } from 'utils/api-client';
import { encodeUrlParams, urlParamsFromUrl } from 'utils/functions';

function useGLMKiloRecords(
  glmKiloFlowId: string | null,
): UseInfiniteQueryResult<AxiosResponse<PaginatedGLMKiloRecordListList>> {
  const fetchRecords = ({
    pageParam = { limit: '20', offset: '0' },
  }: {
    pageParam?: { limit: string; offset: string };
  }): Promise<AxiosResponse<PaginatedGLMKiloRecordListList>> => {
    return client.get(`glm-kilo-records/?glm_kilo_flow_id=${glmKiloFlowId}&${encodeUrlParams(pageParam)}`);
  };
  return useInfiniteQuery(['glm-kilo-records', glmKiloFlowId], fetchRecords, {
    enabled: !!glmKiloFlowId,
    getNextPageParam: page => {
      return page.data.next ? urlParamsFromUrl(page.data.next) : undefined;
    },
  });
}

export default useGLMKiloRecords;
